module.exports = __webpack_public_path__ + "static/media/font_regular.ac327c4d.woff";